import React from "react";

function Universe() {
  return (
    <div className="container mt-5">
      <div className="row text-center">
        <h1>The Zerodha Universe</h1>
        <p>
          Extend your trading and investment experience even further with our
          partner platforms
        </p>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/smallcaseLogo.png" alt="Smallcase Logo" />
          <h5>Thematic Investment Platform</h5>
          <p className="text-small text-muted">
            Invest in curated portfolios based on your preferences and strategies.
          </p>
        </div>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/sensibullLogo.svg" alt="Zetta Logo" />
          <h5>AI-Powered Stock Insights</h5>
          <p className="text-small text-muted">
            Get personalized stock recommendations powered by AI and data analytics.
          </p>
        </div>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/goldenpiLogo.png" alt="CoinBase Logo" />
          <h5>Cryptocurrency Trading</h5>
          <p className="text-small text-muted">
            Buy and sell cryptocurrencies with ease, powered by secure and reliable platforms.
          </p>
        </div>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/sensibullLogo.svg" alt="RoboAdvisor Logo" />
          <h5>Robo-Advisory Services</h5>
          <p className="text-small text-muted">
            Get automated financial advice tailored to your goals and risk profile.
          </p>
        </div>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/goldenpiLogo.png" alt="StockRadar Logo" />
          <h5>Real-Time Market Analytics</h5>
          <p className="text-small text-muted">
            Track real-time stock performance, market trends, and news with precision.
          </p>
        </div>

        <div className="col-lg-4 col-sm-12 p-md-3 mt-5">
          <img src="media/images/sensibullLogo.svg" alt="MutualFund Logo" />
          <h5>Mutual Fund Investments</h5>
          <p className="text-small text-muted">
            Diversify your portfolio with a wide range of mutual fund options.
          </p>
        </div>

        <button className="p-1 p-md-2 btn btn-primary fs-6 mb-4 mb-md-5 signup-button">
          Signup Now
        </button>
      </div>
    </div>
  );
}

export default Universe;
